/**
 * Telegram & WhatsApp integration services.
 * @module services/integrationsService
 */
import { api } from "../lib/api";

export const telegramService = {
  /** @returns {Promise<import("./types").TelegramStatus>} */
  status: () => api.get("/integrations/telegram/status").then((r) => r.data),

  /**
   * @param {string} code 6-digit linking code
   * @returns {Promise<{ok:true, chat_id:number}>}
   */
  link: (code) =>
    api.post("/integrations/telegram/link", { code }).then((r) => r.data),

  /** @returns {Promise<{ok:true}>} */
  unlink: () =>
    api.delete("/integrations/telegram/unlink").then((r) => r.data),

  /** @returns {Promise<{webhook_url:string, telegram_response:any}>} */
  setupWebhook: () =>
    api.post("/integrations/telegram/setup-webhook").then((r) => r.data),
};

export const whatsappService = {
  /** @returns {Promise<import("./types").WhatsAppStatus>} */
  status: () => api.get("/integrations/whatsapp/status").then((r) => r.data),

  /**
   * @param {string} code 6-digit linking code
   * @returns {Promise<{ok:true, phone:string}>}
   */
  link: (code) =>
    api.post("/integrations/whatsapp/link", { code }).then((r) => r.data),

  /** @returns {Promise<{ok:true}>} */
  unlink: () =>
    api.delete("/integrations/whatsapp/unlink").then((r) => r.data),
};
